import { onboardingAPI } from 'api/onboarding/endpoints';
import { OnboardingService } from 'api/onboarding/models';

export const triggerOnboarding = async (
  serviceName: OnboardingService,
  projectId: string,
) => {
  await onboardingAPI.triggerOnboarding(serviceName, projectId);
};
